import React from 'react';
import { palette } from '../../styles/theme';

export function SuccessSVG ({ className, fill = palette.success[400] }) {
    return (
        <svg
            className={className}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_14386_15445)">
                <path
                    d="M34 6.67978C37.0165 8.4215 39.5259 10.9208 41.2796 13.9304C43.0334 16.9399 43.9707 20.3553 43.9989 23.8385C44.027 27.3216 43.1449 30.7517 41.44 33.7892C39.7351 36.8267 37.2665 39.3662 34.2785 41.1564C31.2905 42.9466 27.8867 43.9254 24.4042 43.9959C20.9217 44.0664 17.4811 43.2261 14.4231 41.5583C11.3651 39.8904 8.79574 37.4528 6.96933 34.4868C5.14292 31.5208 4.12282 28.1292 4.01 24.6478L4 23.9998L4.01 23.3518C4.12201 19.8978 5.1271 16.5317 6.92728 13.5818C8.72746 10.6318 11.2613 8.19869 14.2818 6.51955C17.3023 4.84041 20.7063 3.97258 24.162 4.00066C27.6177 4.02874 31.0072 4.95178 34 6.67978ZM31.414 18.5858C31.0696 18.2414 30.6114 18.0346 30.1254 18.004C29.6393 17.9734 29.1588 18.1213 28.774 18.4198L28.586 18.5858L22 25.1698L19.414 22.5858L19.226 22.4198C18.8412 22.1215 18.3607 21.9738 17.8748 22.0045C17.3889 22.0351 16.9308 22.242 16.5865 22.5863C16.2422 22.9306 16.0354 23.3887 16.0047 23.8746C15.974 24.3605 16.1217 24.841 16.42 25.2258L16.586 25.4138L20.586 29.4138L20.774 29.5798C21.1247 29.8519 21.5561 29.9996 22 29.9996C22.4439 29.9996 22.8753 29.8519 23.226 29.5798L23.414 29.4138L31.414 21.4138L31.58 21.2258C31.8785 20.841 32.0263 20.3605 31.9958 19.8744C31.9652 19.3884 31.7584 18.9302 31.414 18.5858Z"
                    fill={fill}
                />
            </g>
            <defs>
                <clipPath id="clip0_14386_15445">
                    <rect width="48" height="48" fill={palette.white} />
                </clipPath>
            </defs>
        </svg>
    );
}
